import React, { useState } from "react";
import { FcAlphabeticalSortingAz, FcAlphabeticalSortingZa } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { MdCheck, MdRefresh } from "react-icons/md";

import { elakayAutoText, getElakayLanguageContext } from "./dataElakay";
import './FilterUserProduct.css';


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
// Current language source: the app-wide one (always up to date after a language switch), else
// the infoSource this module last rendered with.
const __elakayLanguageSource = () => getElakayLanguageContext?.() || __elakayInfoSource;
const __elakayText = (key, fallback) =>
  __elakayLanguageSource()?.laguangeElakay?.("frontElakayHardcodedText", __elakayLanguageSource().languageAPI)?.["filterUserProduct"]?.[key] || fallback;

function processData(data) {
    // Obtenez une liste plate avec tous les noms
    const allNames = data.flatMap(item => item.name);
    const nameCounts = allNames.reduce((acc, name) => {
        acc[name] = (acc[name] || 0) + 1;
        return acc;
    }, {});

    return data?.map(item => {
        // Filtrer les noms qui ne sont pas communs à tous les tableaux
        const filteredNames = item.name.filter(name => nameCounts[name] < data?.length);

        // Trouver un groupe de genre (comme "Men", "Women", "Boys")
        const genderGroup = filteredNames.find(name =>
            ["Men", "Women", "Boys", 'Girls', 'Babies'].includes(name.trim())
        );

        // Construire "cateryName" avec l'élément principal et le groupe de genre
        const categoryNameParts = [genderGroup, item.name[0]].filter(Boolean);
        const categoryName = categoryNameParts.join(" ").trim();

        return {
            ...item,
            cateryName: categoryName
        };
    });
}

const FilterUserProduct = props =>{
    const { 
        infoSource,
        getCategoriesUser =[],
        setSowFilterOurTeam,
        getFilterUserProd,
        setFilterUserProd,
        infoFil,
        loadProductsByArrival,
        filtOrders = [],
        handleFilters,
        setMyFilters,
        myFilters = {filters: {"categoriesID.gategoriesLink": [] }},
        showProdTable,
        extraSections = null // optional context-specific sections (Provider My Products adds Wholesale / Out of stock)
    }=props

     const {
        asc,
        limit,
        unpublished,
        dropshipping,
        sortBy
        } = getFilterUserProd
    __setElakayInfoSource(infoSource);

    // let status = [{value: "none", name: 'none'}, {value: "Not processed", name: 'notProcessed'}, {value: "Processing", name:'processing'},{value: "Shipped", name: 'shipped'}, {value: "Delivered", name:'delivered'}, {value: "Cancelled", name:'cancelled'}] 
    // let statusName = ["Not processed", "Processing", "Shipped", "Delivered", "Cancelled"] 
    let sortByliste = [{value : 'createdAt', name:__elakayText("t002", "by created")} , {value : 'updatedAt', name:__elakayText("t003", "by upadete")}, {value : 'name', name:__elakayText("t004", "by name")}, {value : 'filterProduct.sold', name:__elakayText("t005", "by sold")}, {value : 'filterProduct.quantity', name:__elakayText("t006", "by quantity")}]
    let date = ['days', 'months', 'years']
    const [orderDate, setOrderDate] = useState(filtOrders.orderDate);
    const [myd, setmyd] = useState(filtOrders.myd);

    // Dérivé directement de myFilters (source de vérité unique) plutôt que
    // d'un état "checked" parallèle -- l'ancien état local restait désynchronisé
    // après "Clear All" (myFilters se réinitialisait mais pas "checked"), ce qui
    // faisait réapparaître silencieusement d'anciennes catégories déjà effacées
    // dès qu'on recochait une seule case.
    const selectedCategoryIds = myFilters?.filters?.["categoriesID.gategoriesLink"] || [];

    const handleToggle = (c) => () => {
        const updatedValues = selectedCategoryIds.includes(c)
          ? selectedCategoryIds.filter((id) => id !== c)
          : [...selectedCategoryIds, c];

        handleFilters(updatedValues, "categoriesID.gategoriesLink");
      };

const handlechange = event =>{
    setmyd(event.target.value)
}


const handleDate = event =>{
    let value = event.target.value
    if(value === "days"){
        setmyd(15)
    }else if(value === "months"){
        setmyd(6)
    } else if(value === "years"){
        setmyd(2024)
    }
    setOrderDate(value)
}
const btnfilter = ()=>{
    loadProductsByArrival(infoFil.token, infoFil.DealProduct, myFilters, getFilterUserProd)
    setSowFilterOurTeam(false)
    // setFiltOrders({orderStatus, orderDate, myd})
}

const handleFilterTeam = name => event =>{
    setFilterUserProd({...getFilterUserProd, [name]: event.target.value})
}
const btnClrfilter = ()=>{
  let initialFilter = {
            asc: 'asc',
            unpublished: false,
            dropshipping: false,
            limit : 12,
            sortBy: 'createdAt',
            search: ''
          }
      setMyFilters({filters: {"categoriesID.gategoriesLink": [] }})
      loadProductsByArrival(infoFil.token, infoFil.DealProduct, {filters: {"categoriesID.gategoriesLink": [] }}, initialFilter)
    setFilterUserProd(initialFilter)
    setSowFilterOurTeam(false)
   
}
    const statusForm = ()=>{
        return<div className="my-4"> 
           <div className="m-0 p-1" style={{backgroundColor: "WhiteSmoke"}}> <h5 className="my-0 mx-1  p-1 fw-bold 
             fw-bold">
                {/* Status */}
                {infoSource.laguangeElakay('title', infoSource.languageAPI).status}
                </h5></div>
            {filtOrders?.map((p, i) => (
            <h5 key={i}>
                <input
                    // onChange={()=>setOrderStatus(p.value)}
                    // value={`${p.value}`}
                    name={elakayAutoText("h_48a3661d846478", "status")}
                    type="radio"
                    className="form-check-input mr-2 ml-4 check2"
                    // checked={p.value == orderStatus ? 'checked' : ''}
                    in={"status_" + p.name}
                />
                <label className="form-check-label" htmlFor={"status_" + p.name}>{infoSource.laguangeElakay('label', infoSource.languageAPI)[p.name]}</label>
            </h5>
        ))}
        </div>
    }
    
    const dateForm = ()=>{
        return<div className="my-4"> 
          <div className="m-0 p-1" style={{backgroundColor: "WhiteSmoke"}}>  <h5 className="my-0 mx-1  p-1 fw-bold fw-bold">
            {/* filter date */}
            {infoSource.laguangeElakay('title', infoSource.languageAPI).filterdate}
            </h5></div>
            {date?.map((p, i) => (
            <h5 key={i}>
                <input
                    onChange={handleDate}
                    value={`${p}`}
                    name={elakayAutoText("h_e927d0677c7724", "date")}
                    type="radio"
                    className="form-check-input mr-2 ml-4 check2"
                    checked={p == orderDate ? 'checked' : ''}
                    id={"date_" + p}
                />
                <label className="form-check-label" htmlFor={"date_" + p}>{p}</label>
            </h5>
        ))}
        </div>
    }
    const generateSteps = (step, max) => Array.from({ length: Math.floor(max / step) }, (_, i) => (i + 1) * step);
    const orderBypageselect = ()=>{
    // const pageOrder = [12, 24, 36, 48, 60, 72, 84, 96, 108, 120]
    // const pageOrderTable = [50, 100, 150, 200, 250]


   const pageOrder = generateSteps(12, 1000);
    const pageOrderTable = generateSteps(50, 1000);
let PageLimitOrder = showProdTable ?pageOrderTable : pageOrder;
      return <section className="elakay-user-filter-section">
        <div className="elakay-user-filter-heading">
          <span className="elakay-user-filter-number">01</span>
          <h4>{infoSource.laguangeElakay('title', infoSource.languageAPI).orderPage}</h4>
        </div>
        <select value={limit} onChange={handleFilterTeam('limit')} className="elakay-user-filter-select">
          <option>{infoSource.laguangeElakay('title', infoSource.languageAPI).selOrderPage}</option>
          {PageLimitOrder?.map((c, i) => (
              <option key={i} value={c}>{c}</option>
          ))}
        </select>
      </section>
}


const checInputFil =(a, b)=>{
    return a && a?.map((c, j) => (
        <li key={j} className="elakay-user-category-item">
          <input
            onChange={handleToggle(c._id)}
            type="checkbox"
            checked={selectedCategoryIds.includes(c._id)}
            id={`user-category-${c._id}`}
            className="elakay-user-category-input check2"
          />
          <label className="elakay-user-category-label" htmlFor={`user-category-${c._id}`}>
            <span className="elakay-user-category-box"><FaCheck /></span>
            <span>{c.cateryName}</span>
          </label>
        </li>
     ))
 }

const daySelect = ()=>{
    const allDays = []
    const startDay = 1
    const endDay = 30;

    for (let day = startDay; day <= endDay; day++) {
        allDays.push(day);
    }
      return <div className="my-4"> 
       <div className="m-0 mb-4" style={{backgroundColor: "WhiteSmoke"}}><h5 className="my-0 mx-1  p-1 fw-bold">
        {/* filter by Days */}
        {infoSource.laguangeElakay('title', infoSource.languageAPI).filterDays}
        </h5></div>
      <select value={myd} onChange={handlechange} className="w-50 m-4 form-select">
      <option>
        {/* select the days */}
        {infoSource.laguangeElakay('title', infoSource.languageAPI).selectdays}
        </option>
      {allDays?.map((c, i) => (
            <option key={i} value={c}>
                {c}
            </option>
        ))}
      </select>
 
   </div>
}
const sortByForm = ()=>{
    return <section className="elakay-user-filter-section">
      <div className="elakay-user-filter-heading">
        <span className="elakay-user-filter-number">04</span>
        <h4>{infoSource.language(infoSource, "title", "sortBy")}</h4>
      </div>
      <div className="elakay-user-sort-list">
        {sortByliste?.map((p, i) => {
          const optionId = `user-sort-${i}`;
          return <div className="elakay-user-sort-item" key={p.value}>
            <input
              onChange={handleFilterTeam('sortBy')}
              value={p.value}
              name={elakayAutoText("h_c3adc28a9a4a7a", "sortBy")}
              type="radio"
              className="elakay-user-sort-input check2"
              checked={p.value === sortBy}
              id={optionId}
            />
            <label className="elakay-user-sort-label" htmlFor={optionId}>
              <span className="elakay-user-sort-radio"></span>
              <span>{p.name}</span>
            </label>
          </div>
        })}
      </div>
    </section>
}

const ASC_DESC_Form =()=>{
    
    return <section className="elakay-user-filter-section">
      <div className="elakay-user-filter-heading">
        <span className="elakay-user-filter-number">05</span>
        <h4>{infoSource.language(infoSource, "title", "descAsce")}</h4>
      </div>
      <div className="elakay-user-order-toggle" role="group">
        <button
          type="button"
          className={`elakay-user-order-btn ${asc === "asc" ? "active" : ""}`}
          onClick={()=>setFilterUserProd({...getFilterUserProd, asc: 'asc'})}
        >
          <FcAlphabeticalSortingAz />
          {asc === "asc" && <MdCheck className="elakay-user-order-check" />}
        </button>
        <button
          type="button"
          className={`elakay-user-order-btn ${asc === "desc" ? "active" : ""}`}
          onClick={()=>setFilterUserProd({...getFilterUserProd, asc: 'desc'})}
        >
          <FcAlphabeticalSortingZa />
          {asc === "desc" && <MdCheck className="elakay-user-order-check" />}
        </button>
      </div>
    </section>
    }

const monthsSelect = ()=>{
    const allMonths = []
    const startMonth = 1
    const endMonth = 12;

    for (let month = startMonth; month <= endMonth; month++) {
        allMonths.push(month);
    }
      return <div className="my-4"> 
       <div className="m-0 mb-4" style={{backgroundColor: "WhiteSmoke"}}><h5 className="my-0 mx-1  p-1 fw-bold">
        {/* filter by months */}
        {infoSource.laguangeElakay('title', infoSource.languageAPI).filterMonths}
        </h5></div>
      <select value={myd} onChange={handlechange} className="w-50 m-4 form-select">
      <option>
        {/* select the month */}
        {infoSource.laguangeElakay('title', infoSource.languageAPI).selectmonth}
        </option>
      {allMonths?.map((c, i) => (
            <option key={i} value={c}>
                {c}
            </option>
        ))}
      </select>
 
   </div>
}

const yearsSelect = ()=>{
   const allyears = []
    var currentTime = new Date()
    var curYear = currentTime.getFullYear()
    const startYear = curYear - 6
    const endYear = curYear;

    for (let year = endYear; year >= startYear; year--) {
        allyears.push(year);
    }
      return <div className="my-4"> 
       <div className="m-0 mb-4" style={{backgroundColor: "WhiteSmoke"}}><h5 className="my-0 mx-1  p-1 fw-bold">
        {/* filter by years */}
        {infoSource.laguangeElakay('title', infoSource.languageAPI).filteryears}
        </h5></div>
      <select value={myd} onChange={handlechange} className="w-50 m-4 form-select">
      <option>
        {/* select the year */}
        {infoSource.laguangeElakay('title', infoSource.languageAPI).selectyear}
        </option>
      {allyears?.map((c, i) => (
            <option key={i} value={c}>
                {c}
            </option>
        ))}
      </select>
 
   </div>
}
    const btnForm = ()=>{
        return <div className="elakay-user-filter-actions">
          <button type="button" className="elakay-user-filter-reset" onClick={btnClrfilter}>
            <MdRefresh />
            {infoSource.laguangeElakay('Button', infoSource.languageAPI).clearAll}
          </button>
          <button type="button" className="elakay-user-filter-apply" onClick={btnfilter}>
            <MdCheck />
            {infoSource.laguangeElakay('Button', infoSource.languageAPI).submit}
          </button>
        </div>
    }
    return ( 
        <div className="elakay-user-filters">
        {orderBypageselect()}
        <section className="elakay-user-filter-section elakay-user-publish-section">
          <div className="elakay-user-filter-heading">
            <span className="elakay-user-filter-number">02</span>
            <h4>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).filterUserProduct.t001}</h4>
          </div>
          <label className="elakay-user-switch">
            <input
              type="checkbox"
              name="unpublished"
              checked={unpublished}
              onChange={() => setFilterUserProd({ ...getFilterUserProd, unpublished: !unpublished })}
            />
            <span className="elakay-user-switch-track"><span /></span>
          </label>
        </section>

        <section className="elakay-user-filter-section elakay-user-publish-section">
          <div className="elakay-user-filter-heading">
            <span className="elakay-user-filter-number">02b</span>
            <h4>{elakayAutoText("h_cj_filter_dropshipping_title", "Dropshipping products only")}</h4>
          </div>
          <label className="elakay-user-switch">
            <input
              type="checkbox"
              name="dropshipping"
              checked={dropshipping}
              onChange={() => setFilterUserProd({ ...getFilterUserProd, dropshipping: !dropshipping })}
            />
            <span className="elakay-user-switch-track"><span /></span>
          </label>
        </section>

        <section className="elakay-user-filter-section">
          <div className="elakay-user-filter-heading">
            <span className="elakay-user-filter-number">03</span>
            <h4>{infoSource.language(infoSource, "title", "shopCategories")}</h4>
          </div>
          <ul className="elakay-user-category-list">
            {checInputFil(processData(getCategoriesUser))}
          </ul>
        </section>
        {extraSections}
        {/* {statusForm()} */}
        {sortByForm()}
        {/* {dateForm()}
        {orderDate === 'days' && daySelect()}
        {orderDate === 'months' && monthsSelect()}
        {orderDate === 'years' && yearsSelect()}  */}
        {ASC_DESC_Form()}
        {btnForm()}
         </div>
        )
}
export default FilterUserProduct;
